export default __webpack_public_path__ + "static/media/bluebg.3be7067f.svg";